var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "section-background",
        style: { "background-color": _vm.color }
      },
      [
        _c("div", { staticClass: "section-background__effects" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-background__foreground" },
          [
            _vm.child
              ? _c(_vm.getComponentVue(_vm.child.id), {
                  tag: "component",
                  attrs: {
                    id: _vm.child.id,
                    previewContentType: _vm.previewContentType
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }